import { render } from "./DateIcon.vue?vue&type=template&id=2bfc8ac6"
import script from "./DateIcon.vue?vue&type=script&lang=js"
export * from "./DateIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__